import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import classNames from 'classnames';

const SMALL_SCREEN_WIDTH = 767;

// Note: part of this was copied from BG, we might need to tweak it if we want to make it re-usable
class PointerModal extends Component {
  static propTypes = {
    children: PropTypes.object.isRequired,
    contentClassName: PropTypes.string,
    modalClassName: PropTypes.string,
    pointTo: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      viewPortWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    };
  }

  getDirection() {
    if (this.props.pointTo.mobileDirection && this.state.viewPortWidth < SMALL_SCREEN_WIDTH) {
      return this.props.pointTo.mobileDirection;
    }
    return this.props.pointTo.direction;
  }

  render() {
    const contentClassName = classNames({
      'tour-content': true,
      'upper-arrow': this.getDirection() === 'upper',
      'upper-left-arrow': this.getDirection() === 'upper-left',
      'upper-right-arrow': this.getDirection() === 'upper-right',
      'left-arrow': this.getDirection() === 'left',
      [this.props.contentClassName]: !!this.props.contentClassName,
    });

    return (
      <Modal
        backdropClassName="app-modal__backdrop"
        contentClassName={contentClassName}
        isOpen={true}
        modalClassName={this.props.modalClassName}
      >
        {this.props.children}
      </Modal>
    );
  }
}

export default PointerModal;



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/pointerModal.js